// extracted by mini-css-extract-plugin
export default {"w-full":"Chip_w-full__9lZZC","dot":"Chip_dot__bayV-","chip":"Chip_chip__hR3s7","chipOn":"Chip_chipOn__H20My"};